import { render, staticRenderFns } from "./search_teacher.vue?vue&type=template&id=0fef8db2&scoped=true&"
import script from "./search_teacher.vue?vue&type=script&lang=js&"
export * from "./search_teacher.vue?vue&type=script&lang=js&"
import style0 from "./search_teacher.css?vue&type=style&index=0&id=0fef8db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef8db2",
  null
  
)

export default component.exports